<template>
    <div class="container">
        <div class="column">
            <div class="columns">
                <div class="pagination">
                    <router-link
                        v-if="itemsPage != 1"

                        :to="{
                            name: name,
                            params: { type: type, slug: slug },
                            query: getQueryParams(itemsPage-1)
                        }"

                        class="pagination__item pagination__item--prev"
                    >
                        &lt;
                    </router-link>

                    <router-link
                        v-for="(page, index) in pagesData"

                        :to="{
                            name: name,
                            params: { type: type, slug: slug },
                            query: getQueryParams(page)
                        }"

                        class="pagination__item"
                        :class="{'pagination__item--current': page == itemsPage, 'pagination__item--last': page == itemsPagesCount, 'pagination__dots': page === '...' }"
                        :key="'page' + index"
                    >
                        {{page}}
                    </router-link>

                    <router-link
                        v-if="itemsPage != itemsPagesCount"

                        :to="{
                            name: name,
                            params: { type: type, slug: slug },
                            query: getQueryParams(itemsPage+1)
                        }"

                        class="pagination__item pagination__item--prev"
                    >
                        &gt;
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        itemsPage: {
            type: Number,
            default: 1
        },
        itemsPerPage: {
            type: Number,
        },
        itemsTotalCount: {
            type: Number,
        },
        type: {
            type: String
        },
        name: {
            type: String
        }
    },
    data() {
        return {
            itemsPagesCount: Math.ceil(
                this.itemsTotalCount / this.itemsPerPage
            ),
            pagesData: []
        };
    },
    computed: {
        slug() {
            if(this.$route.params) {
                return this.$route.params.slug;
            } else {
                let url = window.location.href;
                return url.substring(url.lastIndexOf("/") + 1);
            }
        },
        query() {
            return this.$route.query.query;
        },
    },
    watch: {
        itemsPage() {
            this.getPagesData();
        }
    },
    methods: {
        getPagesData() {
            const itemsPagesCount = Math.ceil(
                this.itemsTotalCount / this.itemsPerPage
            );
            const delta = 2;
            const left = Math.max(this.itemsPage - delta, 2);
            const right = Math.min(this.itemsPage + delta, itemsPagesCount - 1);
            let prev;
            const data = [];
            const dataWithDots = [];

            if (itemsPagesCount > 1) {
                data.push(1);
                for (let p = left; p <= right; p++) {
                    data.push(p);
                }
                data.push(itemsPagesCount);
                data.forEach(el => {
                    if (prev) {
                        if (el - prev === 2) {
                            dataWithDots.push(prev + 1);
                        } else if (el - prev !== 1) {
                            dataWithDots.push('...');
                        }
                    }
                    dataWithDots.push(el);
                    prev = el;
                });
            }

            this.pagesData = dataWithDots;
        },
        getQueryParams(page) {
            let obj = {};

            if(this.query) {
                obj.query = this.query;
            }

            if(page !== 1) {
                obj.page = page;
            }

            return obj;
        }
    },
    mounted() {
        this.getPagesData();
    }
}
</script>